var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://www.js365job.com/recruitment/home","id":"mobsf","width":"100%","height":"100%","scrolling":"no","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }